import React, { useState } from 'react';
import { BarsArrowDownIcon, BarsArrowUpIcon } from '@heroicons/react/24/solid';
import useScrollWindow from '@/hooks/useScrollWindow';

interface SideBarLayoutProps {
  children: React.ReactNode;
  initialCollapsed?: boolean;
  onCollapseChange?: (collapsed: boolean) => void;
  buttonClassName?: string;
  containerClassName?: string;
}

const SideBarLayout: React.FC<SideBarLayoutProps> = ({
  children,
  initialCollapsed = false,
  onCollapseChange,
  buttonClassName = 'btn-gradient-pink',
  containerClassName = '',
}) => {
  const [collapsed, setCollapsed] = useState(initialCollapsed);
  const { isMobile, isTablet } = useScrollWindow();
  const isDesktop = !isMobile && !isTablet;

  const toggleCollapsed = () => {
    setCollapsed(prev => {
      const next = !prev;
      if (onCollapseChange) onCollapseChange(next);
      return next;
    });
  };

  return (
    <div className={`lg:relative ${containerClassName}`}>
      {!isDesktop && (
        <button
          onClick={toggleCollapsed}
          className={buttonClassName}
          title={collapsed ? 'Open Sidebar' : 'Close Sidebar'}
        >
          {collapsed ? <BarsArrowDownIcon className="w-5 h-5" /> : <BarsArrowUpIcon className="w-5 h-5" />}
        </button>
      )}

      {!collapsed && (
        <div className="w-full mb-6 lg:mb-0">
          <div className="lg:sticky lg:top-4">{children}</div>
        </div>
      )}
    </div>
  );
};

export default SideBarLayout;
